import { useLayoutEffect } from "react";
import { useLocation } from "react-router";

export function Error() {
	const location = useLocation();

	useLayoutEffect(() => {
		if (location.state === null) {
			alert("잘못된 접근입니다.");
			window.location.replace("/");
		}
	}, []);
}
